(function () {
    try {

    const SelectorsDictionary = {
        ConfigModal: 'div#CC-modal',
        AppOS: 'app-operating-systems',
        OsCheckboxes: 'app-operating-systems input[type="checkbox"]',
        OsOptionRow: 'div.operatingSystemCB',
        OsOptionLabel: 'div.operatingSystemCBL label',
        FinalizeCta: 'button#addChCProduct, button#getQuote',
        SummaryOptionLabels: 'app-current-configuration label.hpe-config-option__label',
    };

    const BODY_CLASS = 'fe-hpe-4066';
    const WINDOWS_OS_NAME = 'Windows Server';

    // The configurator only renders app-operating-systems while the OS tab is
    // active, and only renders the summary while it is expanded. Windows
    // selection is cached here so it can be read from any tab.
    let windowsSelected = false;

    /**
     * Returns the visible CC-modal element (handles duplicate div#CC-modal on page)
     * @returns {jQuery}
     */
    function getVisibleModal() {
        return jQuery(SelectorsDictionary.ConfigModal).filter(':visible');
    }

    /**
     * Reads the rendered OS tab into windowsSelected. No-op when the OS tab is not active.
     */
    function syncOsState() {
        if (!jQuery(SelectorsDictionary.AppOS).is(':visible')) return;

        windowsSelected = Array.from(document.querySelectorAll(SelectorsDictionary.OsCheckboxes))
            .filter(function (input) { return input.checked; })
            .some(function (input) {
                const label = input.closest(SelectorsDictionary.OsOptionRow)?.querySelector(SelectorsDictionary.OsOptionLabel)?.textContent || '';
                return label.includes(WINDOWS_OS_NAME);
            });
    }

    /**
     * Returns true if a Windows Server OS is in the config (brand name, not localized).
     * Prefers the expanded summary, then the rendered OS tab, then the cached state.
     */
    function hasWindowsInConfig() {
        const summaryLabels = jQuery(SelectorsDictionary.SummaryOptionLabels).toArray();
        if (summaryLabels.length > 0) {
            return summaryLabels.some(function (el) { return el.textContent.includes(WINDOWS_OS_NAME); });
        }
        syncOsState();
        return windowsSelected;
    }

    let finalizeCtaHooked = false;

    /**
     * Hooks the primary CTA (Add to cart or Request a quote) via
     * modal-level delegation. Fires a distinct event for each CTA when
     * Windows Server OS is in the config.
     */
    function hookFinalizeCta() {
        if (finalizeCtaHooked) return;
        const modal = getVisibleModal()[0];
        if (!modal) return;

        finalizeCtaHooked = true;
        modal.addEventListener('change', function (e) {
            if (!e.target.closest(SelectorsDictionary.OsCheckboxes)) return;
            setTimeout(syncOsState, 0);
        }, true);

        modal.addEventListener('click', function (e) {
            if (!e.target.closest(SelectorsDictionary.FinalizeCta)) {
                syncOsState();
                return;
            }
            const btn = e.target.closest(SelectorsDictionary.FinalizeCta);
            if (!hasWindowsInConfig()) return;

            let linkName;
            if (btn.id === 'addChCProduct') {
                linkName = 'mp:b2c-configurator:add-to-cart-windows-os-selected';
            } else if (btn.id === 'getQuote') {
                linkName = 'mp:b2c-configurator:request-a-quote-windows-os-selected';
            } else {
                return;
            }
            feTrackMetrics('new.link', { link_name: linkName });
            window.feHPEB2C?.log(feProjectId + ': fired ' + linkName);
        }, true);
    }

    /**
     * Watches for the config modal to open, then hooks the finalize CTA.
     */
    function watchForConfigModal() {
        window.feUtils.observeDom({
            selector: SelectorsDictionary.ConfigModal,
            callback: () => {
                setTimeout(function () {
                    if (getVisibleModal().length > 0) {
                        windowsSelected = false;
                        hookFinalizeCta();
                    }
                }, 1000);
            },
            config: {
                attributes: true,
                childList: false,
                subtree: false,
            }
        });
    }

    function init() {
        $('body').addClass(BODY_CLASS);
        setTimeout(watchForConfigModal, 1000);
    }

    window.feUtils.waitForConditions({
        conditions: ['body'],
        activity: feProjectId,
        callback: init,
    })

    } catch (e) { console.error(e); }
})();
